import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'spin-loader',
    templateUrl: './spin-loader.component.html',
    styleUrls: ['./spin-loader.component.scss'],
})
export class SpinLoaderComponent implements OnInit {
    @Input() type: string = 'spinner'; // 'spinner', 'bounce'
    @Input() bounceSize?: string = '18px';
    bounceStyle: object;

    constructor() {}
    ngOnInit() {
        this.bounceStyle = {
            height: this.bounceSize,
            width: this.bounceSize,
        };
    }
}
